import axios from 'axios';

// Get container tracking information
export const getContainerTracking = async (containerNumber) => {
    try {
        const response = await axios.post(
            `https://api.findteu.com/container/${containerNumber}`,
            null,  // no body data needed
            {
                headers: {
                    'Content-Type': 'application/json',
                    // 'X-Authorization-ApiKey': '123456789'
                    'X-Authorization-ApiKey': 'XudpH9nVcS-16186-nZnSoBExGb-MgZz6su1QT'
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error.response && error.response.data.detail
            ? error.response.data.detail
            : error.message;
    }
}; 